import styled from 'styled-components'
import { devices } from '../../../globalStyle'

export const Container = styled.div`
  display: flex;
  width: 12vw;
  height: 5.5vh;
  margin-top: 3vh;
  margin-left: 36.5vw;
  border: 2px #0090d3 solid;
  border-radius: 2vw;
  background-color: #fff;
  align-items: center;
  cursor: pointer;

  @media ${devices.largeDesktop} {
  margin-left: 39.8vw;
    width: 8vw;
    height: 3.5vh;
    margin-top: 3rem;
  }
`

export const ButtonImg = styled.img`
  margin-left: 1.5vw;
  height: 2.4vh;

  @media ${devices.largeDesktop} {
    margin-left: 1vw;
    height: 1.6vh;
  }
`

export const ButtonText = styled.h2`
  color: #0090d3;
  margin-left: 0.5vw;
  margin-top: 1.12vw;
  margin-bottom: 1vw;
  font-family: 'Inter', sans-serif;
  font-size: 1.1vw;
  font-weight: bold;

  @media ${devices.largeDesktop} {
    font-size: 0.7vw;
  }
`
